<svg:g #ticksel>
  @for (tick of ticks; track tick) {
    <svg:g class="tick" [attr.transform]="transform(tick)">
      <title>{{ tickFormat(tick) }}</title>
      <svg:text
        stroke-width="0.01"
        [attr.dy]="dy"
        [attr.x]="x1"
        [attr.y]="y1"
        [attr.text-anchor]="textAnchor"
        [style.font-size]="'12px'"
        >
        {{ tickTrim(tickFormat(tick)) }}
        </svg:text>
        </svg:g>
      }
      </svg:g>
      @if (referenceLineLength > 1 && refMax && refMin && showRefLines) {
        <svg:path
          class="reference-area"
          [attr.d]="referenceAreaPath"
          [attr.transform]="gridLineTransform()"
          />
      }
      @for (tick of ticks; track tick) {
        <svg:g [attr.transform]="transform(tick)">
          @if (showGridLines) {
            <svg:g [attr.transform]="gridLineTransform()">
              @if (orient === Orientation.Left) {
                <svg:line
                  class="gridline-path gridline-path-horizontal"
                  x1="0"
                  [attr.x2]="gridLineWidth"
                  />
              }
              @if (orient === Orientation.Right) {
                <svg:line
                  class="gridline-path gridline-path-horizontal"
                  x1="0"
                  [attr.x2]="-gridLineWidth"
                  />
              }
              </svg:g>
            }
            </svg:g>
          }
          <svg:g #referenceLinesEl>
            @if (showRefLines) {
              <ng-container>
                @for (refLine of referenceLines; track refLine) {
                  <svg:g>
                    <svg:g [attr.transform]="transform(refLine.value)">
                      <svg:line
                        class="refline-path gridline-path-horizontal"
                        x1="0"
                        [attr.x2]="gridLineWidth"
                        [attr.transform]="gridLineTransform()"
                        />
                        @if (showRefLabels) {
                          <svg:g>
                            <title>{{ tickTrim(tickFormat(refLine.value)) }}</title>
                            <svg:text
                              class="refline-label"
                              [attr.dy]="dy"
                              [attr.y]="-6"
                              [attr.x]="gridLineWidth"
                              [attr.text-anchor]="textAnchor"
                              >
                              {{ refLine.name }}
                              </svg:text>
                              </svg:g>
                            }
                            </svg:g>
                            </svg:g>
                          }
                        </ng-container>
                      }
                      </svg:g>
